import { makeSx } from '../../../../theme/_utils'
import { defaultPalette } from '../../../../theme/idsTheme'

export default makeSx({
    button: {
        background: defaultPalette.lightGrey.half,
        color: defaultPalette.typography.main,
        paddingY: '0.375rem',
        paddingX: '0.75rem',
        borderRadius: '0.375rem',
        fontSize: '0.75rem',
        cursor: 'pointer',
        lineHeight: '1.75rem',
        '& .MuiButton-startIcon': {
            '& svg': {
                width: '1.125rem',
                height: '1.125rem',
            },
        },
    },
})
